<template>
  <v-dialog
    content-class="documentDialog"
    max-width="1000px"
    v-model="viewDialogSuggestion"
    transition="scale-transition"
    persistent
    >
    <v-btn dark small
      class="suggestion_btn"
      slot="activator"
      color="primary">
      <v-icon>add</v-icon>Suggest TR News Publisher
    </v-btn>
    <v-card >
      <v-card-title class="primary white--text title">
        Send us a suggestion
      </v-card-title>
      <v-card-text >
        <p>The current content of the TR Toolbox consists of a curated selection of relevant sources of information available in the TR Universe.</p>
        <p>The TR Toolbox team is always happy to enrich this knowledge base following the community interests, hence we kindly invite you to suggest anything relevant to your business that you would like to see indexed in the TR Toolbox.</p>
        <v-textarea
          v-model="suggestionMessage"
          box
          auto-grow
          data-vv-name="suggestionMessage"
          :error-messages="errors.collect('suggestionMessage')"
          v-validate="'required'"
          required
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="viewDialogSuggestion = false">Close</v-btn>
          <v-btn color="primary" @click.native="sendMail()">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SuggestionForm',
  data () {
    return {
      viewDialogSuggestion: false,
      suggestionMessage: '',
      suggestionSendResult: '',
      dictionary: {
        custom: {
          suggestionMessage: {
            required: () => 'Message can not be empty'
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize('en', this.dictionary)
  },
  methods: {
    post (url, body, callback) {
      let req = new XMLHttpRequest()
      req.open('POST', url, true)
      req.setRequestHeader('Content-Type', 'application/json')
      req.addEventListener('load', function () {
        if (req.status < 400) {
          callback(null, JSON.parse(req.responseText))
        } else {
          callback(new Error(`Request failed: ${req.statusText}`))
        }
      })
      req.send(JSON.stringify(body))
    },
    async sendMail () {
      let check = await this.$validator.validateAll()
      if (!check) { return }
      if (this.suggestionMessage !== '') {
        const payload = {
          name: this.userProfile.name,
          company: 'null',
          email: this.userProfile.email,
          comment: `TR-TOOLBOX SUGGESTION PRESS:\n${this.suggestionMessage}`,
          optin: 'null'
        }
        this.post(process.env.VUE_APP_AWS_LAMBDA_EMAIL_URL, payload, function (err, res) {
          if (err) { this.suggestionSendResult = 'error' }
          this.suggestionSendResult = 'success'
        })
      }
      this.suggestionMessage = ''
      this.viewDialogSuggestion = false
    }
  },
  computed: {
    ...mapState(['userProfile'])
  }
}
</script>
<style>

</style>
